import React from "react";

export default function RiskFinancingHeader({
  settings,
}) {
  return (
    <div>
      <p className="text-xs uppercase tracking-[0.25em] text-slate-400">
        Strategic Intelligence
      </p>

      <h1 className="text-2xl font-semibold text-slate-900 mt-1">
        Risk Financing
      </h1>

      <p className="text-sm text-slate-500 mt-1">
        Analyze how digital risk is reduced, transferred,
        retained, and financed.
      </p>

      {settings && (
        <p className="text-xs text-slate-400 mt-1">
          Currency: {settings.currency || "USD"} · Monte Carlo
          iterations:{" "}
          {Number(
            settings.simulations ?? 0
          ).toLocaleString()}
        </p>
      )}
    </div>
  );
}
